module.exports = __webpack_public_path__ + "img/png.cb510005.svg";